<template>
  <div class="comp-divider">
    <p class="content" v-markdown="attributes.value"></p>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'

export default {
  props: ['attributes'],
  methods: {
    isVisible (el, offsetTop = 0.7, offsetBottom = 0.3) {
      if (!el) return false
      const rect = el.getBoundingClientRect()
      const isVisible =
        rect.bottom > rect.height * +offsetBottom &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) * +offsetTop /* or $(window).height() */

      return isVisible
    }
  },
  mounted () {
    const _this = this
    document.addEventListener('scroll', throttle(function () {
      if (_this.isVisible(_this.$el)) {
        _this.$el.classList.add('visible')
      } else {
        _this.$el.classList.remove('visible')
      }
    }, 100))
  }
}
</script>

<style lang="scss">
.component.component-divider {
  padding-top: 10px;
  padding-bottom: 10px;

  .component-content {
    padding: 60px 0 1px;
    margin-bottom: 20px;
    border-bottom: 1px dotted #000000;
  }

  .comp-divider {
    text-align: center;
    position: relative;
    
    .content {
      position: relative;
      &:before {
        z-index: -1;
        content: "_";
        color: transparent;
        position: absolute;
        left: 0;
        background-color: $yellow;;
        background: linear-gradient(to bottom, transparent 29%, #FFF200 29%, #FFF200 72%, transparent 72%);
        width: 0%;
        height: 100%;
        bottom: 0;
        transition: width 1s ease-in-out;
      }
    }

    p {
      text-align: center;
      vertical-align: bottom;
      max-width: 540px;
      font-family: $font-CuratorRegular;
      line-height: 25px;
      font-size: 17px;
      letter-spacing: 5.2px;
      color: #000000;
      display: inline;
      padding-left: 5px;

      strong {
        font-family: $font-CuratorBold;
      }
    }

    &.visible {
      .content:before {
        width: 100%;
      }
    }
  }
}
</style>
